import mockAxios, { AxiosResponse } from 'axios';
import { IFormTemplateServiceMock } from './form-template.mock.types';

export const mockFormTemplateService = (): IFormTemplateServiceMock => ({
  fetchFormTemplates: jest.fn(),
  fetchFormTemplate: jest.fn(),
  createFormTemplate: jest.fn(),
  updateFormTemplate: jest.fn(),
  deleteFormTemplate: jest.fn(),
  updateFormTemplateState: jest.fn(),

  //fields
  fetchFormFields: jest.fn(),
  fetchFormField: jest.fn(),
  createFormField: jest.fn(),
  updateFormField: jest.fn(),
  deleteFormField: jest.fn(),

  //todos
  fetchFormFieldOptionTodos: jest.fn(),
  fetchFormFieldOptionTodo: jest.fn(),
  createFormFieldOptionTodo: jest.fn(),
  updateFormFieldOptionTodo: jest.fn(),
  deleteFormFieldOptionTodo: jest.fn(),

  //todo-templates
  fetchFormTodoTemplates: jest.fn(),
  fetchFormTodoTemplate: jest.fn(),
  createFormTodoTemplate: jest.fn(),
  updateFormTodoTemplate: jest.fn(),
  deleteFormTodoTemplate: jest.fn()
});

export const mockFormTemplateAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
